module.exports = {"321282001":"靖城街道","321282101":"新桥镇","321282102":"东兴镇","321282103":"斜桥镇","321282104":"西来镇","321282105":"季市镇","321282106":"孤山镇","321282108":"生祠镇","321282109":"马桥镇","321282401":"城南","321282402":"新港城","321282403":"城北园区","321282404":"江阴园区","321282406":"滨江新城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321282.json
// module id = 1033
// module chunks = 0